export default __webpack_public_path__ + "static/media/iconAlert.2cf054c3.svg";